import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useEffect, useRef, useState } from 'react';
import axiosAuth from '../utils/axiosAuth.ts';


const AddPlayerInput = ({teamData, setTeamData}) => {
    const [newPlayerName, setNewPlayerName] = useState('');
    const [newPlayerEmail, setNewPlayerEmail] = useState('');
    const [newPlayerCell, setNewPlayerCell] = useState('');
    const [addPlayerMessage, setAddPlayerMessage] = useState('');
    const [addPlayerMessageStyle, setAddPlayerMessageStyle] = useState({color: 'red'});
    const [isAddingPlayer, setIsAddingPlayer] = useState(false);
    const inputRef = useRef(null);

    const teamApiUrl = `/teams/${teamData.id}`;
    const playerApiUrl = teamApiUrl + '/players/';


    useEffect(() => {
        inputRef.current.focus();
    }, []);

    const printUnsuccesfulAddPlayerMessage = (msg) => {
        setAddPlayerMessage(msg);
        setAddPlayerMessageStyle({ color: 'red' });
    }

    const printSuccesfulAddPlayerMessage = (msg) => {
        setAddPlayerMessage(msg);
        setAddPlayerMessageStyle({ color: 'green' });
    }

    const generatePlayerId = (playerName) => {
        const playerId = playerName.replace(/\s/g, '').toLowerCase()
            + Math.floor(Math.random() * 900000000 + 100000000);

        return playerId;
    }

    const handleAddPlayerFormSubmit = (event) => {
        event.preventDefault();
        addPlayer();
    }

    const isValidEmail = (email) => {
        const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        return regex.test(email);
    }

    const addPlayer = async () => {
        // Make sure to validate the name input before adding the player
        if (newPlayerName !== '') {
            setIsAddingPlayer(true);
            const trimmedNewPlayerName = newPlayerName.trim().replace(/\s+/g, ' ');
            // Check if email is a valid format
            if (newPlayerEmail !== '' && !isValidEmail(newPlayerEmail)) {
                printUnsuccesfulAddPlayerMessage('Please enter a valid email');
            }
            // If new player name is already on the team
            else if (Object.values(teamData.players).some(player => player.toLowerCase() === trimmedNewPlayerName.toLocaleLowerCase())) {
                printUnsuccesfulAddPlayerMessage('Player name already exists on team');
            } else {
                const newPlayerData = {
                    teamId: teamData.id,
                    playerId: generatePlayerId(trimmedNewPlayerName),
                    playerName: trimmedNewPlayerName,
                    email: newPlayerEmail,
                    cellNumber: newPlayerCell
                }

                await axiosAuth.post(playerApiUrl + encodeURIComponent(newPlayerData.playerId), newPlayerData);

                // If successful, update team data
                const response = await axiosAuth.get(teamApiUrl);
                console.log('Team data: ', response.data);
                setTeamData(response.data);

                printSuccesfulAddPlayerMessage(`${trimmedNewPlayerName} added successfully`);
                inputRef.current.focus();
                setNewPlayerName('');
                setNewPlayerEmail('');
                setNewPlayerCell('');
            }
            
        }
        else {
            setNewPlayerName('');
            setNewPlayerEmail('');
            setNewPlayerCell('');
            setAddPlayerMessage('');
        }
        setIsAddingPlayer(false);
    };


    return (
        <form className='add-player-form' onSubmit={handleAddPlayerFormSubmit}>
            <TextField
                inputRef={inputRef}
                id="add-player-name"
                label="Player Name"
                value={newPlayerName}
                onChange={(event) => {
                    setNewPlayerName(event.target.value);
                }}
                helperText=' '
            />
            <TextField
                id="add-player-email"
                label="Player Email"
                value={newPlayerEmail}
                onChange={(event) => {
                    setNewPlayerEmail(event.target.value);
                }}
                helperText=' '
            />
            <TextField
                id="add-player-cell"
                label="Player Cell"
                type='tel'
                value={newPlayerCell}
                onChange={(event) => {
                    setNewPlayerCell(event.target.value);
                }}
                helperText=' '
            />
            <Button variant="contained" type='submit' disabled={isAddingPlayer}>
                Add Player
            </Button>
            <p className='add-player-message' style={addPlayerMessageStyle}>{addPlayerMessage}</p>
        </form>
    );
}

export default AddPlayerInput;